export default function addAPIVersion(apiVersion: string, url: string): string {
  const prefix = url.includes('?') ? '&' : '?'
  return `${url + prefix}api-version=${apiVersion}`
}
